import heroImage from "@/assets/hero-roberto-new.png";

function Hero() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div style={{ position: "relative", background: "var(--navy)" }}>
      {/* Glow */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          width: 700,
          height: 700,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(198,169,106,0.055) 0%, transparent 70%)",
          right: "-5%",
          top: "50%",
          transform: "translateY(-50%)",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      <section
        style={{
          minHeight: "100vh",
          display: "grid",
          gridTemplateColumns: "1fr 400px",
          alignItems: "center",
          gap: "5rem",
          padding: "8rem 5vw 5rem",
          position: "relative",
          overflow: "hidden",
          maxWidth: 1200,
          margin: "0 auto",
          zIndex: 1,
        }}
        className="hero-section"
      >
        {/* Left: content */}
        <div className="hero-animate" style={{ position: "relative", zIndex: 1 }}>
          {/* Tag */}
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.6rem",
              flexWrap: "wrap",
              fontSize: "0.72rem",
              letterSpacing: "0.22em",
              textTransform: "uppercase",
              color: "var(--gold)",
              marginBottom: "2rem",
            }}
          >
            <span
              style={{
                display: "block",
                width: "2rem",
                height: "1px",
                background: "var(--gold)",
                flexShrink: 0,
              }}
            />
            SENIOR PMM · AMSTERDAM
          </div>

          {/* Headline */}
          <h1
            style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontSize: "clamp(2.8rem, 4.8vw, 4.6rem)",
              fontWeight: 300,
              lineHeight: 1.08,
              marginBottom: "2rem",
              color: "var(--dp-white)",
              letterSpacing: "-0.01em",
            }}
          >
            Strategy is half the job.
          </h1>

          {/* Bio */}
          <p
            style={{
              color: "var(--dp-muted)",
              fontSize: "1.02rem",
              maxWidth: "50ch",
              lineHeight: 1.9,
              marginBottom: "2.8rem",
            }}
          >
            Senior PMM with 10+ years in B2B SaaS, developer tools, and AI/ML. I lead positioning
            and GTM, and handle the execution layer: CRO, lifecycle, messaging architecture, sales
            enablement.
          </p>

          {/* Actions */}
          <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", alignItems: "center" }}>
            <a href="https://ehazzhswtowuskdmgibz.supabase.co/storage/v1/object/public/pescelab-main-site/CV%20Roberto%20Pesce.pdf" className="btn-primary" target="_blank" rel="noopener noreferrer">
              <svg
                viewBox="0 0 16 16"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                style={{
                  width: 14,
                  height: 14,
                  display: "inline",
                  marginRight: "0.4rem",
                  verticalAlign: "middle",
                }}
              >
                <path d="M8 2v8M5 7l3 3 3-3M3 12h10" />
              </svg>
              Download CV
            </a>
            <button onClick={() => scrollTo("contact")} className="btn-ghost">
              Get in Touch
            </button>
          </div>
        </div>

        {/* Right: photo */}
        <div className="hero-photo-animate" style={{ position: "relative", zIndex: 1 }}>
          <div style={{ position: "relative", width: "100%" }}>
            <div
              aria-hidden="true"
              style={{
                position: "absolute",
                top: -16,
                right: -16,
                width: "55%",
                height: "55%",
                borderTop: "1px solid rgba(198,169,106,0.4)",
                borderRight: "1px solid rgba(198,169,106,0.4)",
                pointerEvents: "none",
              }}
            />
            <div
              aria-hidden="true"
              style={{
                position: "absolute",
                bottom: -16,
                left: -16,
                width: "35%",
                height: "35%",
                borderBottom: "1px solid rgba(198,169,106,0.25)",
                borderLeft: "1px solid rgba(198,169,106,0.25)",
                pointerEvents: "none",
              }}
            />
            <img
              src={heroImage}
              alt="Roberto Pesce"
              style={{
                width: "100%",
                display: "block",
                filter: "grayscale(15%) contrast(1.04)",
                borderRadius: 2,
              }}
            />
            <div
              aria-hidden="true"
              style={{
                position: "absolute",
                inset: 0,
                background: "linear-gradient(to top, rgba(13,20,32,0.5) 0%, transparent 45%)",
                borderRadius: 2,
              }}
            />
          </div>
        </div>

        {/* Responsive overrides */}
        <style>{`
          @media (max-width: 960px) {
            .hero-section {
              grid-template-columns: 1fr !important;
              text-align: center;
              padding-top: 100px !important;
            }
            .hero-section .hero-animate p {
              max-width: none !important;
            }
            .hero-section .hero-animate > div:last-child {
              justify-content: center !important;
            }
            .hero-section .hero-photo-animate > div {
              max-width: 300px;
              margin: 0 auto;
            }
          }
        `}</style>
      </section>
    </div>
  );
}

export { Hero };
